var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                size: "small",
                model: _vm.inputForm,
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "表单名称",
                            prop: "name",
                            rules: [
                              {
                                required: true,
                                message: "表单名称不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写表单名称" },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "表单key",
                            prop: "code",
                            rules: [
                              {
                                required: true,
                                message: "表单key不能为空",
                                trigger: "blur",
                              },
                              {
                                validator: _vm.validateKeyNoExist,
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写表单编码" },
                            model: {
                              value: _vm.inputForm.code,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "code", $$v)
                              },
                              expression: "inputForm.code",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "所属数据库",
                            prop: "dataSource.id",
                            rules: [
                              {
                                required: true,
                                message: "所属数据库不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c("SelectTree", {
                            ref: "dataSourceTree",
                            attrs: {
                              props: {
                                value: "id", // ID字段名
                                label: "label", // 显示名称
                                children: "children", // 子级字段名
                              },
                              data: _vm.dataSourceTree,
                              value: _vm.inputForm.dataSource.id,
                              label: _vm.inputForm.dataSource.name,
                              clearable: true,
                              accordion: true,
                              disabled: _vm.method !== "add",
                            },
                            on: {
                              getValue: function (id, label, node) {
                                ;(_vm.inputForm.dataSource.id = id),
                                  (_vm.inputForm.dataSource.enName =
                                    node.enName),
                                  (_vm.inputForm.dataSource.type = node
                                    ? node.dbType
                                    : "")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "是否自动建表",
                            prop: "autoCreate",
                            rules: [
                              {
                                required: true,
                                message: "是否自动建表不能为空",
                                trigger: "blur",
                              },
                            ],
                          },
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { disabled: _vm.method !== "add" },
                              on: { change: _vm.changeAutoCreate },
                              model: {
                                value: _vm.inputForm.autoCreate,
                                callback: function ($$v) {
                                  _vm.$set(_vm.inputForm, "autoCreate", $$v)
                                },
                                expression: "inputForm.autoCreate",
                              },
                            },
                            _vm._l(
                              _vm.$dictUtils.getDictList("yes_no"),
                              function (item) {
                                return _c(
                                  "el-radio",
                                  {
                                    key: item.id,
                                    attrs: { label: item.value },
                                  },
                                  [_vm._v(_vm._s(item.label))]
                                )
                              }
                            ),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _vm.inputForm.autoCreate === "0"
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "表名",
                                prop: "tableName",
                                rules: [
                                  {
                                    required: true,
                                    message: "表名不能为空",
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    disabled: _vm.method !== "add",
                                    filterable: "",
                                    placeholder: "请选择表",
                                  },
                                  model: {
                                    value: _vm.inputForm.tableName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.inputForm, "tableName", $$v)
                                    },
                                    expression: "inputForm.tableName",
                                  },
                                },
                                _vm._l(_vm.dataTable, function (item) {
                                  return _c("el-option", {
                                    key: item.name,
                                    attrs: {
                                      label: item.nameAndComments,
                                      value: item.name,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "表名",
                                prop: "tableName",
                                rules: [
                                  {
                                    validator: _vm.validateValid,
                                    trigger: "blur",
                                  },
                                  {
                                    required: true,
                                    message: "表名不能为空",
                                    trigger: "blur",
                                  },
                                  {
                                    validator: _vm.validateTableNoExist,
                                    trigger: "blur",
                                  },
                                ],
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: {
                                    disabled: _vm.method !== "add",
                                    placeholder: "请输入表名",
                                  },
                                  model: {
                                    value: _vm.inputForm.tableName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.inputForm, "tableName", $$v)
                                    },
                                    expression: "inputForm.tableName",
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "append",
                                        disabled: _vm.method !== "add",
                                      },
                                      on: { click: _vm.createTableName },
                                      slot: "append",
                                    },
                                    [_vm._v("生成随机表名")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "备注信息",
                            prop: "remarks",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写备注信息",
                            },
                            model: {
                              value: _vm.inputForm.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "remarks", $$v)
                              },
                              expression: "inputForm.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: {
                        size: "small",
                        type: "primary",
                        icon: "el-icon-circle-check",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }